export const cs = {
    languages: {
        cs: 'Čeština',
        de: 'Němčina',
        en: 'Angličtina',
        es: 'Španělština',
        fr: 'Francouzština',
        hr: 'Chorvatština',
        hu: 'Maďarština',
        it: 'Italština',
        nl: 'Nizozemština',
        pl: 'Polština',
        ru: 'Ruština',
        sk: 'Slovenština',
        tr: 'Turečtina',
        uk: 'Ukrajinština',
        undefined: 'Bez titulků',
    },
    player: {
        content: {
            notFound: { title: 'Chyba při načítání mediálního prvku 😞' },
        },
        controls: {
            backwards: { title: '10s zpět' },
            buffering: { title: 'Načítání...' },
            captions: { title: 'Titulky' },
            forwards: { title: '10s vpřed' },
            fullscreen: { title: 'Celá obrazovka' },
            pause: { title: 'Pauza' },
            play: { title: 'Přehrát' },
            playlist: { title: 'Seznam stop' },
            volume: { title: 'Hlasitost' },
        },
    },
};
